import React from 'react';
import {IWizardStepViewModel} from "components/WizardSteps/WizardStepsModel";
interface Props {
  activeWizardStep?: any;  
  wizardLabels?:any
}

const WizardSteps = ({ activeWizardStep, wizardLabels}: Props) => {
  
  const wizardStepViewModelList:IWizardStepViewModel[] = [];
  const WizardStepLabels:string[] =[wizardLabels?.ChoosePaymentPlanStepLabel,wizardLabels?.ChoosePaymentPlanStepSmallScreenLabel,
                                    wizardLabels?.ChoosePaymentMethodStepLabel,wizardLabels?.ChoosePaymentMethodStepSmallScreenLabel,
                                    wizardLabels?.ConfirmPaymentMethodAndPlanStepLabel, wizardLabels?.ConfirmPaymentMethodAndPlanStepSmallScreenLabel];
                                   
  
 const BuildWizardSteps = () =>{    
    const noOfWizardSteps:any = Math.round((WizardStepLabels.length/2))
    var labelIndex = 0;
    for (var i = 1; i <= noOfWizardSteps; i++) {
      var label = WizardStepLabels[labelIndex];
      labelIndex++;                
      var smallScreenLabel = WizardStepLabels[labelIndex];
      const stepViewModel ={
        label:label,
        smallScreenLabel:smallScreenLabel,
        isActive:activeWizardStep?.ActiveStep == i,
        isCompleted:activeWizardStep?.ActiveStep > i
      }
      wizardStepViewModelList.push(stepViewModel); 
      labelIndex++;      
  }    
    return wizardStepViewModelList;
  }

  const GetCssClassForStep = (wizardStep:IWizardStepViewModel) =>{

    if (wizardStep.isActive) return "ProgressIndicator-current";
        if (wizardStep.isCompleted) return "ProgressIndicator-done";
        return "";
  }

  return (
    
    <ul className="Progress">
      {(BuildWizardSteps() || []).map((step:any,index:number)=>(

      <li className={"Progress-step" + " " + GetCssClassForStep(step) +" " +(activeWizardStep.HideStepNumbers ? "Progress--noNumbers" : "")}>
      <span className="ProgressStep-number">{index + 1}</span>
            <div className="Progress-indicator">
            </div>
            <span className="Progress-text Text-lgScreen">
                {step.label}
            </span>
            <span className="Progress-text Text-smScreen">
                {step.smallScreenLabel}
            </span>
        </li>
      
      ))}    
    </ul>
  )
};

export default WizardSteps;
